import type { Socket } from "socket.io-client";
import { useSharingStore } from "../sharingStore";
import { useESSStore, SharedComic } from "../essStore";
import { GENERIC_ERROR, STORY_NOT_FOUND_ERROR, STORY_ALREADY_SHARED_ERROR } from "../errorMessages";
import { trackError } from "../../services/metrics";

export function registerSharingHandlers(socket: Socket) {
  socket.on("shareTargets", (data: { siblings: Array<{ customerId: string; name?: string; avatarUri?: string }> }) => {
    useSharingStore.getState().setShareTargets(data.siblings);
  });

  socket.on("comicShared", (data: { shareId: string; comicId: string; recipientId: string }) => {
    useSharingStore.getState().setShareSuccess(data.recipientId);
    const current = useSharingStore.getState().sharesSent;
    useSharingStore.getState().setSharesSent([
      ...current,
      { shareId: data.shareId, recipientId: data.recipientId, sharedAt: Date.now() },
    ]);
  });

  socket.on("shareError", (data: { error: string; code?: string }) => {
    console.error("[Share] Error:", data.code, data.error);
    trackError("Sharing", data.code || "unknown");
    const message = data.code === "NOT_FOUND" ? STORY_NOT_FOUND_ERROR
      : data.code === "ALREADY_SHARED" ? STORY_ALREADY_SHARED_ERROR
      : GENERIC_ERROR;
    useSharingStore.getState().setShareError(message);
    useSharingStore.getState().setLoadingTargets(false);
  });

  socket.on("sharesSentList", (data: { comicId: string; shares: Array<{ shareId: string; recipientId: string; sharedAt: number }> }) => {
    useSharingStore.getState().setSharesSent(data.shares);
  });

  socket.on("sharedComicList", (data: { comics: SharedComic[]; nextToken?: string; isAppend?: boolean }) => {
    if (data.isAppend) {
      useESSStore.getState().appendSharedComics(data.comics, data.nextToken);
    } else {
      useESSStore.getState().setSharedComics(data.comics, data.nextToken);
    }
  });
}
